export const FETCH_INITIAL_GROUPS_REQUEST = "FETCH_INITIAL_GROUPS_REQUEST";
export const FETCH_INITIAL_GROUPS_SUCCESS = "FETCH_INITIAL_GROUPS_SUCCESS";
export const FETCH_INITIAL_GROUPS_FAILURE = "FETCH_INITIAL_GROUPS_FAILURE";

export const FETCH_AUTOCOMPLETE_GROUPS_REQUEST =
  "FETCH_AUTOCOMPLETE_GROUPS_REQUEST";
export const FETCH_AUTOCOMPLETE_GROUPS_SUCCESS =
  "FETCH_AUTOCOMPLETE_GROUPS_SUCCESS";
export const FETCH_AUTOCOMPLETE_GROUPS_FAILURE =
  "FETCH_AUTOCOMPLETE_GROUPS_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/groups/types.js